import { render, staticRenderFns } from "./ProjectPlan.vue?vue&type=template&id=712960f4&scoped=true&"
import script from "./ProjectPlan.vue?vue&type=script&lang=js&"
export * from "./ProjectPlan.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPlan.vue?vue&type=style&index=0&id=712960f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712960f4",
  null
  
)

export default component.exports